<template>
  <div>
    <div class="eventInformation">
      <v-container>
        <v-layout>
          <v-flex md8 xs12 class="terms" v-if="!this.event">
            <h3>One moment please.</h3>
            <p>
              If this message persists, we may have encountered a problem.
              Please email <a href="mailto:amaze@rti.org">amaze@rti.org</a> and
              let us know.
            </p>
          </v-flex>
          <v-flex md8 xs12 class="terms" v-else>
            <h3>Waiver and Release Form</h3>

            <div>
              <p>
                The terms and conditions (“Agreement”) laid out below apply to
                Research Triangle Institute, using the trade name of RTI
                International (“RTI”)
                <strong>2024 Pre-Summit Study Visit</strong>
                (“Study Visit”) and participants thereof. “Participants” are
                defined as paid participants on the Study Visit and the paid
                member’s employer. Participant’s information may be found in the
                Study Visit confirmation email (“Study Visit Registration
                Form”). The following terms “Study Visit Activities” are defined
                in the Study Visit Description documentation available for
                download and attached to these terms and conditions.
              </p>

              <h4>Entire Agreement.</h4>

              <p>
                This Agreement, together with any documents incorporated herein
                by reference, constitutes the sole and entire agreement of the
                parties with respect to Participant’s participation in the Study
                Visit, and supersedes all prior or contemporaneous
                understandings, agreements, negotiations, representations, and
                communications, both written and oral, with respect to the
                subject matter of the Study Visit. This Agreement expressly
                limits Participant’s acceptance to the terms and conditions of
                the Agreement. This Agreement prevails over any terms or
                conditions contained in any other documentation, and the only
                consideration any subsequent documentation provided by
                Participant shall have is for administrative purposes such as
                the facilitation of invoicing. Reference by RTI to any purchase
                order number supplied by Participant shall be for accounting
                identification purposes only, and any terms or conditions
                therein or in any acknowledgment, confirmation, or other
                communication by Participant in addition to or in conflict with
                this Agreement are rejected.
              </p>

              <h4>Confidentiality.</h4>

              <p>
                During the Study Visit, it may be necessary for either or both
                parties to disclose (a “Disclosing Party”) to the other (the
                “Receiving Party”) certain scientific, technical, business,
                and/or trade secret information that the Disclosing Party
                regards as Proprietary Information. “Proprietary Information” is
                defined as (1) all written information disclosed that is marked
                on its face as proprietary, and (2) all orally or visually
                disclosed information that is identified as proprietary at the
                time of disclosure and within thirty (30) days after disclosure,
                is summarized and confirmed in writing to the other party as
                proprietary. A Receiving Party will maintain confidence in all
                Proprietary Information made available to it during the Term of
                this Agreement for a period of two years from the expiration of
                termination of this Agreement. The Receiving Party shall not use
                Proprietary Information received from the Disclosing Party,
                other than for the Purpose or in relation to work that may be
                performed under subsequent agreement between the parties,
                without the prior written consent of the Disclosing Party. The
                Receiving Party shall be held to the same standard of care in
                protecting Proprietary Information as the Receiving Party
                normally takes to preserve and safeguard its own proprietary
                information of a similar type, but in no event less than
                reasonable care.
              </p>

              <h4>Photography, audio, and video recording.</h4>

              <p>
                The Study Visit is held in public spaces including the <a
                  rel="noopener"
                  target="_blank"
                  href="https://www.marriott.com/event-reservations/reservation-link.mi?id=1691060800660&key=GRP&app=resvlink"
                  >Sheraton Imperial Hotel Raleigh-Durham</a
                >, 4700 Emperor Blvd, Durham, NC
                27703 and designated NC Early College High Schools, and
                Participants are prohibited from photographing or video or audio
                taping Study Visit Activities. Further, should Study Visit
                Activities be recorded by RTI for distribution to Participants,
                Participants are prohibited from further distributing the
                recording without prior written permission from RTI. RTI
                reserves the right to use images taken at the Study Visit
                Activities with Participant’s likeness in future marketing
                materials. RTI may edit, alter, copy, exhibit, distribute and
                publish in print, video, audio recorded productions, and on the
                World Wide Web material from the Study Visit for purposes of
                publicizing RTI programs or other lawful purpose without payment
                or any other consideration. The photography, audio and video
                recording will become the property of RTI, stored in a place
                chosen by RTI and will not be returned to Participants. In
                addition, Participants waive the right to inspect or approve the
                finished product, including written or electronic copy, wherein
                Participants’ likeness appears. Participants waive any right to
                royalties or other compensation arising or related to the use of
                the photography or audio and video recording.
              </p>

              <h4>RTI Methods.</h4>

              <p>
                Notwithstanding anything to the contrary herein, RTI shall
                retain ownership of all proprietary data, concepts, methods,
                techniques, processes, protocols, adaptations, ideas, formulas,
                software, databases, know-how, tools, trade secrets, background
                technologies, and standards of judgment (collectively “RTI
                Methods”) owned, licensed, or controlled by RTI prior to this
                Agreement. Participant expressly acknowledges that performance
                of this Agreement may result in the development of improvements
                to the RTI Methods or the development of new RTI Methods.
                Participant agrees that any such improvements to or new RTI
                Methods shall belong exclusively to RTI, and Participant shall
                not, other than as necessary to performance of this Agreement,
                make use of or disclose the same to any other party without the
                prior written consent of RTI.
              </p>

              <h4>Admittance.</h4>

              <p>
                In our sole discretion, without refund, RTI reserves the right
                to refuse admittance to or expel from the Study Visit anyone
                that we determine is behaving in a manner that could be
                disruptive.
              </p>

              <h4>Emergencies.</h4>

              <p>
                Participants will report any and all injuries to RTI staff
                immediately. Should any medical emergency arise, Participants
                will first call 911.
              </p>

              <h4>Alcohol, Drug, and Smoking Policy.</h4>

              <p>
                Drinking alcohol will not be permitted on premises during the
                Study Visit. Participants found possessing or using illicit
                drugs, as defined by United States federal law, will be required
                to leave the Study Visit immediately and may be held criminally
                liable. RTI prohibits smoking (including vaping) on premises
                during the Study Visit.
              </p>

              <h4>Valuables.</h4>

              <p>
                Participants are solely responsible for any valuables they
                decide to bring to the Study Visit. RTI is not responsible for
                belongings left on Study Visit premises.
              </p>

              <h4>Visitor Tags.</h4>

              <p>
                Participants will be issued a visitor tag upon arriving at the
                <a
                  rel="noopener"
                  target="_blank"
                  href="https://www.marriott.com/event-reservations/reservation-link.mi?id=1691060800660&key=GRP&app=resvlink"
                  >Sheraton Imperial Hotel Raleigh-Durham</a
                > and signing in at the registration
                table. Participants will display the tags while attending the
                Study Visit. Tags are valid for named Participant only and
                cannot be transferred. Participants may be asked for
                photographic ID during the Study Visit. If Participant is unable
                to provide identification, which matches the tag, Participant
                may be asked to leave the Study Visit. Tags will expire at the
                end of the Study Visit. Participants will restrict themselves to
                the areas designated for the Study Visit and in accordance with
                the Study Visit schedule/agenda.
              </p>

              <h4>Invoices.</h4>

              <p>
                RTI will send invoices to Participant’s named point of contact
                at the named email address upon registration. RTI payment terms
                are NET 30 days upon receipt of an RTI invoice. Participant will
                not be obligated to pay RTI costs that exceed the amount
                authorized by the Study Visit Registration Form.
              </p>

              <h4>Cancellation, Refund, and Substitution.</h4>

              <p>
                Participant may cancel registration up to thirty (30) calendar
                days before the Study Visit by providing written notice of
                cancellation to RTI using the instructions on the registration
                website Provided the registered Participant cancels by written
                notice within the allowable timeframe, RTI will either cancel
                the invoice or refund the registration fee to the entity who
                made payment on behalf of the Participant. Participants who
                provide written notice of cancellation within thirty (30)
                calendar days prior to the Study Visit are not eligible for a
                refund and shall still be obligated to pay RTI for the full
                fixed price agreed to on the Study Visit Registration Form. If
                the Study Visit registration fee has not been received by RTI,
                the entity responsible for making payment on behalf of the
                Participant shall still be invoices and payment shall be due.
                Substitutions of Participants may be made up to fourteen (14)
                days before the Study Visit. Substitutions must be made within
                the allowable timeframe by providing written notice using the
                instructions on the registration website and by communication
                with CELL around travel arrangements. The refund and
                cancellation policy will not be waived. In the event RTI must
                cancel the Study Visit due to unforeseen circumstances, RTI will
                refund the cost of registrations paid. However, RTI does not
                assume responsibility for any additional costs, charges, or
                expenses, including any charges made for travel and lodging.
              </p>

              <h4>Indemnification and Limitation of Liability.</h4>

              <p>
                Participants, hereby release, waive liability, discharge, hold
                harmless, indemnify, and covenant not to sue the RTI or
                participating NC Early College schools for any and all liability
                incurred in the conduct of, this Study Visit. The liability of
                either party for damages from any cause related to or arising
                out of the Study Visit, whether in contract or in tort,
                including negligence, shall be limited to actual (excluding
                special, indirect, punitive, loss profits, or consequential)
                damages. Participants’ recovery of damages from RTI shall be
                limited to the price detailed to in the Study Visit Registration
                Form. Liability arising out of damages caused by or resulting
                from actions or negligence of Participants shall be solely the
                responsibility of the Participants.
              </p>

              <p>
                Participant will report any and all injuries to RTI and Sheraton
                Imperial staff immediately. Should any medical emergency arise,
                Participant will first call 911.
              </p>

              <p>
                RTI executives are the only staff members empowered to grant
                exceptions to any Conference policies or other general RTI
                practices. Participants will not hold RTI liable for any
                erroneous statements made by other staff members regarding
                exceptions to fees or policies.
              </p>

              <h4>Dispute Resolution.</h4>

              <p>
                In the event of any dispute arising out of the Study Visit, the
                parties shall use good faith efforts to resolve their
                differences amicably within sixty (60) days of the first written
                notice of the dispute. During such sixty (60) day period, the
                parties may agree to utilize a mediator experienced in the field
                of commercial disputes to assist with the resolution of such
                dispute(s). In the event the parties are unsuccessful, the
                parties agree to submit their dispute to binding arbitration by
                one arbitrator to be agreed upon by the parties. The arbitration
                shall be conducted informally in a manner agreed to by the
                parties in consultation with the arbitrator and not in strict
                accordance with the American Arbitration Association rules. The
                decision of the arbitrator shall be binding on the parties and
                the parties waive all rights to seek redress in the courts. The
                parties will share equally the cost of any mediator and/or
                arbitrator and such proceedings, but both parties will be
                responsible for their own travel, employee, and legal costs.
              </p>

              <h4>Choice of Law.</h4>

              <p>
                This Agreement shall be construed and governed in accordance
                with the laws of the State of North Carolina, without giving
                effect to its conflict of law provisions.
              </p>

              <h4>Modifications.</h4>

              <p>
                RTI shall notify Participants in writing for any changes to the
                Study Visit that may be required.
              </p>

              <h4>Force Majeure.</h4>

              <p>
                Neither party shall be liable for any failure or delay in
                performance of Study Visit Activities (other than for delay in
                the payment of money due and payable hereunder) to the extent
                said failures or delays are caused by events beyond that party’s
                reasonable control and occurring without its fault or negligence
                (a “Force Majeure Event”).
              </p>

              <h4>Waiver/Severability.</h4>

              <p>
                Failure of either party to enforce any of its rights hereunder
                shall not constitute a waiver of such rights. If any provision
                herein is or becomes invalid, illegal, or unenforceable, such
                provision shall be deemed modified only to the extent necessary
                to conform with applicable laws.
              </p>

              <h4>Iran Divestment and No Boycott of Israel.</h4>

              <p>
                Pursuant to Article 6E NCGS § 147-86.60, RTI certifies that it
                is not identified on a list created by the NC State Treasurer
                pursuant to NCGS §147-86.58 as a company engaging in investment
                activities in Iran. RTI further certifies that in the
                performance of this Agreement it shall not use any contractor or
                subcontractor that is identified on such a list. Similarly,
                pursuant to Article 6G NCGS §147-86.80, RTI further certifies
                that it is not identified on a list created by the NC State
                Treasurer pursuant to NCGS §147-86.82 as a company investing in
                any company engaged in a boycott of Israel.
              </p>

              <h4>Jessica Lunsford Act.</h4>

              <p>
                As required by NCGS §115C-332.1 for Study Visit Activities
                occurring on school premises, RTI represents and warrants that
                it is aware of and in compliance with NCGS §115C-332.1 E-Verify
                Compliance. Pursuant to NCGS §143.133.3, RTI represents and
                warrants that it is aware of and in compliance with Article 2 of
                Chapter 64 of the North Carolina General Statutes, requiring use
                of the E-Verify system for employers who employ twenty-five (25)
                or more employees, and that it is and will remain in compliance
                with these laws at all times while providing services.
              </p>

              <h4>Contractors, Subcontractors.</h4>

              <p>
                RTI shall ensure that any of its subcontractors (of any tier)
                will remain in compliance with NCGS §147-86.59, §147-86.58,
                §143.133.3, and §115C-332.1 while providing subcontracted
                services in connection with this Agreement.
              </p>
            </div>

            <p>
              NAME: {{ name }}<br />

              DATE: {{ date }}
            </p>
            <div v-if="!accepted">
              <v-form ref="termsForm">
                <v-checkbox required v-model="terms" :rules="rules.terms">
                  <template slot="label"
                    >By checking this box, you agree to the terms and
                    conditions.<span class="star">*</span></template
                  >
                </v-checkbox>
                <v-btn
                  class="ml-0"
                  color="primary"
                  @click="submitTerms()"
                  v-if="!submitted"
                  >Submit</v-btn
                >
                <v-progress-circular v-else indeterminate />
              </v-form>
            </div>
            <div v-else>
              <h4>Thank you!</h4>
              <p v-if="accepted_date">
                You accepted the terms and conditions
                <strong>{{ accepted_date | localTime }} ago</strong>.
              </p>
              <p>
                Please be on the lookout for more messages from us as we lead up
                to the event.<br />We are looking forward to having you join us!
              </p>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: null,
      name: "",
      date: new Date().toLocaleDateString(),
      event: "",
      event_date: "",
      event_waiver: "default",
      terms: null,
      accepted: false,
      accepted_date: null,
      submitted: false,
      rules: {
        terms: [
          (v) => !!v || "You must accept the terms and conditions to continue."
        ]
      }
    };
  },
  methods: {
    submitTerms() {
      if (this.$refs.termsForm.validate()) {
        this.submitted = true;
        this.$http
          .put("registration/terms/" + this.user.uuid, { terms: 1 })
          .then((response) => {
            this.accepted = true;
            // this.accepted_date = response.data.data[0].updated_at;
            this.$store.commit("updateMessage", {
              message: "The terms have been accepted.",
              snackbar: true
            });
          });
      }
    }
  },
  computed: {
    waiver: function () {
      // For now we assume that there are two flavors of waivers:
      // Default (on location) and virtual.
      switch (this.event_waiver.trim().toLowerCase()) {
        case "virtual":
          return "virtual";
        default:
          return "default";
      }
    },
    defaultWaiver: function () {
      return this.waiver === "default";
    },
    virtualWaiver: function () {
      return this.waiver === "virtual";
    }
  },
  mounted() {
    if (!this.$route.params.uuid) {
    }
    this.$http.get("registration/terms/" + this.$route.params.uuid).then(
      (response) => {
        this.user = response.data.data[0];
        this.name = this.user.name;
        this.event = this.user.registration.registration_event.name;
        this.event_date = this.user.registration.registration_event.dates;
        this.event_waiver =
          this.user.registration.registration_event.content.waiver || "default";
        if (this.user.terms) {
          this.terms = this.user.terms;
          this.accepted = true;
          this.accepted_date = this.user.updated_at;
        }
        this.$store.commit("updateMessage", {
          message: "Please review the terms and conditions.",
          snackbar: true
        });
      },
      (response) => {
        this.$store.commit("updateMessage", {
          message:
            "Error: Your information was not found. Please contact support.",
          snackbar: true
        });
        this.$router.push({ path: "/event/missing-token" });
      }
    );
  }
};
</script>
